import { PropsWithChildren, useEffect, useRef, useState } from 'react'
import { ShadowBox } from '../ShadowBox'
import { isMobile } from 'react-device-detect'

export const Layout = ({ children }: PropsWithChildren) => {
  const popupRef = useRef<HTMLDivElement>(null)

  return <div className="">{children}</div>
}
